<template>
    <div class="balcao-sucesso-view">
        <div class="success-container">
            <h1>Pedido enviado com sucesso!</h1>
            <div class="pedido-info">
                <p><strong>Senha do Pedido:</strong> {{ senha }}</p>
                <p><strong>Status:</strong> {{ status }}</p>
            </div>
            <button @click="voltarAoInicio" class="btn-voltar">Voltar ao Início</button>
        </div>
    </div>
</template>

<script>
export default {
    name: "BalcaoSucessoView",
    props: {
        senha: {
            type: String,
            required: true
        },
        status: {
            type: String,
            required: true
        }
    },
    methods: {
        voltarAoInicio() {
            this.$router.push('/');
        }
    }
}
</script>

<style scoped>
.balcao-sucesso-view {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    background: linear-gradient(to bottom, var(--cor1), var(--cor2));
    color: white;
}

.success-container {
    text-align: center;
    background: rgba(255, 255, 255, 0.9);
    padding: 40px;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    max-width: 400px;
    width: 90%;
}

.success-container h1 {
    color: var(--cor1);
    margin-bottom: 20px;
}

.pedido-info p {
    font-size: 18px;
    margin: 10px 0;
    color: black;
}

.btn-voltar {
    margin-top: 20px;
    padding: 10px 20px;
    background: var(--cor1);
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-size: 16px;
}

.btn-voltar:hover {
    background: var(--cor2);
}
</style>